var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextStopMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H6V8H4V20H2V8H0V0ZM8 17.7361V19C8 19.5523 8.4477 20 9 20C9.5523 20 10 19.5523 10 19V18.5H17V19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19V17.7361C19.6137 17.1868 20 16.3885 20 15.5V7.23607C20 6.11549 19.348 4.97653 18.1214 4.61791C17.1075 4.32149 15.5379 4 13.5 4C11.4621 4 9.8925 4.32149 8.8786 4.61791C7.65203 4.97653 7 6.11549 7 7.23607V15.5C7 16.3885 7.38625 17.1868 8 17.7361ZM18 8.75V11.25H9V8.75H18ZM11 15.5C11.5523 15.5 12 15.0523 12 14.5C12 13.9477 11.5523 13.5 11 13.5C10.4477 13.5 10 13.9477 10 14.5C10 15.0523 10.4477 15.5 11 15.5ZM17 14.5C17 15.0523 16.5523 15.5 16 15.5C15.4477 15.5 15 15.0523 15 14.5C15 13.9477 15.4477 13.5 16 13.5C16.5523 13.5 17 13.9477 17 14.5Z",
    fill: "#008C23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextStopMarker);
export default __webpack_public_path__ + "static/media/nextStopMarker.3338a7459013842828ae3c61091e3f79.svg";
export { ForwardRef as ReactComponent };